"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importDefault(require("styled-components"));
var dictionary_1 = __importDefault(require("../../../dictionary"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var GenericButton_1 = __importDefault(require("../../common/GenericButton"));
var selectors_1 = require("../../common/selectors");
var atoms_1 = require("../../styles/atoms");
var selectors_2 = require("../selectors");
var OwnDesignBtn = function () {
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_1.isCustomStoreSelector);
    var filters = (0, selectors_2.useFiltersSelector)(isCustomStore);
    return (react_1.default.createElement(atoms_1.Div, { visible: !isCustomStore },
        react_1.default.createElement(Link, { href: filters.cod, onClick: function () {
                return (0, track_event_1.default)({
                    category: 'store button',
                    action: 'create_design',
                });
            }, target: "_blank" },
            react_1.default.createElement(GenericButton_1.default, null, dictionary_1.default.store.Own_design))));
};
var Link = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  &:hover {\n    text-decoration: none;\n  }\n"])));
exports.default = OwnDesignBtn;
var templateObject_1;
